import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function TrackPageViews() {
  const location = useLocation();

  const trackPageView = () => {
    if (typeof window !== "undefined" && (window as any).fbq) {
      (window as any).fbq("track", "PageView"); // Meta Pixel
    }
    if (typeof window !== "undefined" && (window as any).gtag) {
      (window as any).gtag("config", "AW-XXXXXXX", {
        page_path: location.pathname,
      });
    }
  };

  useEffect(() => {
    trackPageView();
  }, [location]);

  return null;
}
